export const FREE_TRIAL_CONFIG = {
	DEFAULT_DAYS: 1,
	DEFAULT_SOURCE: 'violerts.com',
};
